import { __assign } from 'tslib';
import React__default, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GenericErrorBoundary } from './components/GenericErrorBoundary/index.js';

function withSuspense(WrappedComponent, options) {
    return function (props) {
        var LoadingComponent = options === null || options === void 0 ? void 0 : options.LoadingComponent;
        return (React__default.createElement(ErrorBoundary, { onError: function (error, info) {
                console.error("[Boundary error]", error, info);
                (options === null || options === void 0 ? void 0 : options.onError) && options.onError(error, info);
            }, FallbackComponent: (options === null || options === void 0 ? void 0 : options.CustomErrorComponent) || GenericErrorBoundary },
            React__default.createElement(Suspense, { fallback: (LoadingComponent && React__default.createElement(LoadingComponent, __assign({}, props))) || null },
                React__default.createElement(WrappedComponent, __assign({}, props)))));
    };
}

export { withSuspense };
//# sourceMappingURL=index.js.map
